/* eslint-disable indent */
/* eslint-disable no-nested-ternary */
import {
  Button,
  Card,
  DatePicker,
  Dialog,
  Input,
  NumberPicker,
  Radio,
  Table,
} from '@alifd/next';
import { DeleteOutlined } from '@ant-design/icons';
import { Cascader, Form, InputNumber, message, Space, Typography } from 'antd';
import axios from 'axios';
import moment from 'moment';
import React, { useEffect, useMemo, useRef, useState } from 'react';

import useService from '@/lib/hooks/useService';
import { generateHouseHoldNumberCascader } from '@/utils/generateHouseHoldNumberCascader';

import client from '../../../../lib/feathers';
import styles from './index.module.scss';

const RadioGroup = Radio.Group;

const { TextArea } = Input;

const initValuesForDistributePointsForm = {
  point: null,
  householdNumber: [],
  expirationDate: null,
  remarks: '',
};

const HouseholdPoints = ({ showButton }) => {
  const [form] = Form.useForm();
  const [form1] = Form.useForm();
  const uploadRef = useRef(null);
  const uploadAnnouncement = useRef(null);
  const [
    pointsRecords,
    updateResidentPointsRecord,
    residentPointsRecordService,
  ] = useService({
    collectionName: 'residentPointsRecord',
    query: {
      $sort: {
        createdTime: -1,
      },
    },
  });
  const residentAccountNumbers = client.service('residentAccountNumbers');
  const communityData = client.service('communityData');
  const announcement = client.service('announcement');
  const uploads = client.service('uploads');
  const [residentPointsRecordArr, setResidentPointsRecordArr] = useState([]);
  const [residentPointsFilter, setResidentPointsFilter] = useState([]);
  const [addAddPointsDialog, setAddAccountingDialog] = useState(false);
  const [cascadeArr, setCascadeArr] = useState([]);
  const [residentsData, setResidentsData] = useState([]);
  const [communityDataArr, setCommunityDataArr] = useState([]);
  const [announcementDialog, setAnnouncementDialog] = useState(false);
  const [userName, setUserName] = useState('');
  const [uploadPath, setUploadPath] = useState('');
  const [uploadData, setUploadData] = useState(null);
  const [uploadAnnouncementData, setUploadAnnouncementData] = useState(null);
  const [disable, setDisable] = useState(true);
  const [pointFile, setPointFile] = useState({});

  // 取得住戶資料
  useEffect(() => {
    (async () => {
      try {
        const result = await residentAccountNumbers.find({ query: {} });
        const communityResult = await communityData.find({ query: {} });
        const userData = await client.reAuthenticate();

        const newData = result.data.map((data) => {
          const newHouseholdNumber = data.householdNumber.split('-');
          return { ...data, householdNumber: newHouseholdNumber };
        });
        setResidentsData(newData);
        setCommunityDataArr(communityResult.data[0]);
        setUserName(userData.user.name);
        setResidentPointsRecordArr(pointsRecords);
        setResidentPointsFilter(pointsRecords);
        setPointFile(communityResult.data[0].pointFile);
      } catch (error) {
        console.error(error);
      }
    })();
  }, [communityData, pointsRecords, residentAccountNumbers]);

  useEffect(() => {
    const objectData = [];

    // layer1
    residentsData.forEach((data) => {
      const number = data.householdNumber;
      if (!objectData.find((item) => item.value === number[0])) {
        objectData.push({ value: number[0], label: number[0], children: [] });
      }
    });
    // layer2
    residentsData.forEach((data) => {
      const number = data.householdNumber;
      if (number[1] !== undefined) {
        if (
          !objectData
            .find((item) => item.value === number[0])
            .children.find((item) => item.value === number[1])
        ) {
          objectData
            .find((item) => item.value === number[0])
            .children.push({
              value: number[1],
              label: number[1],
              children: [],
            });
        }
      }
    });
    // layer3
    residentsData.forEach((data) => {
      const number = data.householdNumber;
      if (number[2] !== undefined && number[1] !== undefined) {
        if (
          !objectData
            .find((item) => item.value === number[0])
            .children.find((item) => item.value === number[1])
            .children.find((item) => item.value === number[2])
        ) {
          objectData
            .find((item) => item.value === number[0])
            .children.find((item) => item.value === number[1])
            .children.push({ value: number[2], label: number[2] });
        }
      }
    });
    setCascadeArr(objectData);
  }, [residentsData]);

  const onFinish = async (value) => {
    const householdNumbers = value.householdNumber.map((household) =>
      household.join('-')
    );

    const createRequests = householdNumbers.map(async (householdNumber) => {
      try {
        await residentPointsRecordService.create({
          ...value,
          type: '手動新增',
          point: parseInt(value.point, 10),
          expirationDate: moment(value.expirationDate).valueOf(),
          householdNumber,
        });
        await axios(
          `/ezcon/api/communityPoints?householdNumber=${householdNumber}`,
          {
            method: 'GET',
            headers: {
              authorization: window.localStorage['feathers-jwt'],
            },
          }
        );
      } catch (error) {
        console.error(error);
        message.error(`住戶${householdNumber}的點數新增失敗!`);
      }
    });

    try {
      await Promise.all(createRequests);
      form.resetFields();
      updateResidentPointsRecord();
      setAddAccountingDialog(false);
      message.success('新增成功');
    } catch (error) {
      console.error(error);
      message.error('新增失敗!');
    }

    // // 更新住戶點數
    // const updateResidentBuyPoints = async (resident) => {
    //   let nowPoint = 0;
    //   if (resident.buyPoint) {
    //     nowPoint = resident.buyPoint;
    //   }
    //   let point = 0;
    //   point = parseInt(nowPoint, 10) + parseInt(value.point, 10);

    //   try {
    //     residentAccountNumbers.patch(resident._id, {
    //       buyPoint: point,
    //     });
    //   } catch (error) {
    //     console.error(error);
    //     message.error(`發生錯誤! ${error}，點數資料更新失敗!`);
    //   }
    // };

    // const updateResidentPointPeriod = async (resident) => {
    //   try {
    //     residentAccountNumbers.patch(resident._id, {
    //       pointPeriod: [
    //         ...resident.pointPeriod,
    //         {
    //           [moment(value.expirationDate).valueOf()]: value.point,
    //         },
    //       ],
    //     });
    //   } catch (error) {
    //     console.error(error);
    //     message.error(`發生錯誤! ${error}，點數資料更新失敗!`);
    //   }
    // };

    // try {
    //   const res = await residentAccountNumbers.find({
    //     query: {
    //       householdNumber: {
    //         $in: householdNumbers,
    //       },
    //     },
    //   });
    //   const updateRequests = res.data.map(
    //     value.expirationDate
    //       ? updateResidentPointPeriod
    //       : updateResidentBuyPoints
    //   );
    //   await Promise.all(updateRequests);

    //   message.success('點數資料更新完畢!');
    // } catch (error) {
    //   console.error(error);
    //   message.error(`發生錯誤! ${error}，點數資料更新失敗!`);
    // }
  };

  const onFinishAnnouncement = async (value) => {
    try {
      let newAnnounceFile = {};
      if (uploadAnnouncementData) {
        const body = new FormData();
        body.append('files', uploadAnnouncementData);
        const res = await fetch('/newUploads?type=announcement', {
          method: 'POST',
          body,
          headers: {
            authorization: window.localStorage['feathers-jwt'],
          },
        });

        newAnnounceFile = await res.json();
      }
      console.log(newAnnounceFile);
      await announcement.create({
        ...value,
        createdTime: moment().valueOf(),
        updatedTime: moment().valueOf(),
        type: '一般公告',
        announcementTime: value.announcementTime.valueOf(),
        fileType: 'file',
        files: [
          {
            name: pointFile?.name ? pointFile.name : newAnnounceFile.name,
            response: {
              ...(pointFile?.name
                ? {
                    oldName: pointFile.name,
                    showPath: pointFile.path,
                    id: pointFile.id,
                  }
                : newAnnounceFile),
            },
          },
        ],
        allows: [],
        broadcastStatus: false,
        broadcastGroupId: null,
        MessageStatus: false,
        checkedStatus: false,
        calendarStatus: false,
        calendarId: null,
        announcer: userName,
      });

      //連動更新communityData
      await communityData.patch(communityDataArr._id, {
        ...communityDataArr,
        pointFile: {
          path: newAnnounceFile.showPath,
          name: newAnnounceFile.oldName,
          id: newAnnounceFile._id,
        },
      });
      setAnnouncementDialog(false);
      message.success('新增成功');
    } catch (error) {
      console.log(error);
    }
  };

  const cascaderOptionsForDistributePoints = useMemo(() => {
    const householdNumbers = residentsData.map((resident) =>
      resident.householdNumber.join('-')
    );
    return generateHouseHoldNumberCascader(householdNumbers);
  }, [residentsData]);

  return (
    <>
      <Cascader
        className={styles.searchHousehold}
        options={cascadeArr}
        expandTrigger="hover"
        placeholder="戶號查詢"
        onChange={(value) => {
          if (value) {
            setResidentPointsRecordArr(
              residentPointsFilter.filter((item) => {
                return item.householdNumber === value.join('-');
              })
            );
          } else {
            setResidentPointsRecordArr(residentPointsFilter);
          }
        }}
      />

      {/* 新增點數記錄 */}
      <Dialog
        hasMask
        className={styles.dialog}
        visible={addAddPointsDialog}
        onOk={() => {
          form.submit();
        }}
        onCancel={() => {
          form.resetFields();
          setAddAccountingDialog(false);
        }}
        onClose={() => {
          form.resetFields();
          setAddAccountingDialog(false);
        }}
      >
        <Form
          form={form}
          name="basic"
          labelCol={{ span: 6 }}
          wrapperCol={{ span: 18 }}
          onFinish={onFinish}
          autoComplete="off"
          initialValues={initValuesForDistributePointsForm}
        >
          <h3>新增點數發放</h3>
          <Form.Item
            label="發放點數"
            name="point"
            rules={[{ required: true, message: '請輸入發放點數' }]}
          >
            <InputNumber
              min={0}
              placeholder="請輸入發放點數"
              className={styles.pointInput}
            />
          </Form.Item>

          <Form.Item
            label="發放對象"
            name="householdNumber"
            rules={[{ required: true, message: '請選擇發放對象' }]}
          >
            <Cascader
              options={cascaderOptionsForDistributePoints}
              placeholder="請選擇發放對象"
              multiple
              showCheckedStrategy="SHOW_CHILD"
              displayRender={(label) => label.join('-')}
            />
          </Form.Item>
          <Form.Item label="點數使用到期日" name="expirationDate">
            <DatePicker />
          </Form.Item>
          <Form.Item label="備註" name="remarks">
            <TextArea placeholder="請輸入備註" maxLength={100} hasLimitHint />
          </Form.Item>
        </Form>
      </Dialog>

      {/* 點數參數設定 */}
      <div style={{ marginBottom: 10 }}>
        <Card free>
          <Card.Content>
            <h3>點數參數設定</h3>
            <div style={{ marginBottom: 10 }}>
              1.住戶於繳交管理費後，將會依坪數匯入住戶點數帳戶(1坪=
              <NumberPicker
                disabled={disable}
                defaultValue={0}
                value={
                  communityDataArr?.managementFeeConvertPoint
                    ? communityDataArr.managementFeeConvertPoint
                    : 0
                }
                onChange={(value) => {
                  const newObject = { ...communityDataArr };
                  newObject.managementFeeConvertPoint = value;
                  setCommunityDataArr(newObject);
                }}
              />
              點)
            </div>
            <div style={{ marginBottom: 10 }}>
              2.若住戶選擇以年繳方式繳交管理費，將會於每月
              <NumberPicker
                disabled={disable}
                defaultValue={1}
                value={
                  communityDataArr?.annualPaymentImportDate
                    ? communityDataArr.annualPaymentImportDate
                    : 1
                }
                onChange={(value) => {
                  const newObject = { ...communityDataArr };
                  newObject.annualPaymentImportDate = value;
                  setCommunityDataArr(newObject);
                }}
              />
              號匯入點數
            </div>
            <div>
              3.是否提供儲值點數功能：
              <RadioGroup
                disabled={disable}
                value={
                  communityDataArr?.isBuyPoint || communityDataArr.isBuyPoint
                    ? 'true'
                    : 'false'
                }
                onChange={(value) => {
                  const newValue = value === 'true';
                  const newObject = { ...communityDataArr };
                  newObject.isBuyPoint = newValue;
                  setCommunityDataArr(newObject);
                }}
              >
                <Radio value="true">是</Radio>
                <Radio value="false">否</Radio>
              </RadioGroup>
            </div>
            <div>
              4.點數提供現金儲值方式（1點＝
              <NumberPicker
                disabled={disable}
                defaultValue={1}
                value={
                  communityDataArr?.pointValue ? communityDataArr.pointValue : 1
                }
                onChange={(value) => {
                  const newObject = { ...communityDataArr };
                  newObject.pointValue = value;
                  setCommunityDataArr(newObject);
                }}
              />
              元），將會併入下個月帳單進行繳費
            </div>
            <div style={{ marginBottom: 10 }}>
              5.是否清空每月匯入點數：{' '}
              <RadioGroup
                disabled={disable}
                value={
                  communityDataArr?.isClearPoint ||
                  communityDataArr.isClearPoint
                    ? 'true'
                    : 'false'
                }
                onChange={(value) => {
                  const newValue = value === 'true';
                  const newObject = { ...communityDataArr };
                  newObject.isClearPoint = newValue;
                  setCommunityDataArr(newObject);
                }}
              >
                <Radio value="true">是</Radio>
                <Radio value="false">否</Radio>
              </RadioGroup>
            </div>
            {communityDataArr.isClearPoint && (
              <div style={{ marginBottom: 10 }}>
                6.點數將會於
                <NumberPicker
                  disabled={disable}
                  value={
                    communityDataArr?.clearDate ? communityDataArr.clearDate : 1
                  }
                  onChange={(value) => {
                    const newObject = { ...communityDataArr };
                    newObject.clearDate = value;
                    setCommunityDataArr(newObject);
                  }}
                />
                天過後清空
              </div>
            )}
            {
              <div style={{ marginBottom: 10 }}>
                <Space wrap>
                  <Button
                    disabled={disable}
                    style={{ marginRight: 10 }}
                    onClick={() => {
                      uploadRef.current.click();
                    }}
                  >
                    {communityDataArr?.pointFile?.name
                      ? '更換檔案'
                      : '檔案上傳'}
                  </Button>
                  {uploadData && (
                    <>
                      <Typography.Text type="secondary">
                        {uploadData.name}
                      </Typography.Text>
                      <Button
                        disabled={disable}
                        text
                        onClick={() => {
                          setUploadData(null);
                          setUploadPath('');
                        }}
                        style={{ opacity: 0.45 }}
                      >
                        <DeleteOutlined style={{ marginLeft: 10 }} />
                      </Button>
                    </>
                  )}
                  {!uploadData && communityDataArr?.pointFile?.name && (
                    <>
                      <Typography.Text type="secondary">
                        {communityDataArr?.pointFile?.name}
                      </Typography.Text>
                      <Button
                        disabled={disable}
                        text
                        onClick={() => {
                          const newObject = { ...communityDataArr };
                          newObject.pointFile = null;
                          setCommunityDataArr(newObject);
                        }}
                        style={{ opacity: 0.45 }}
                      >
                        <DeleteOutlined style={{ marginLeft: 10 }} />
                      </Button>
                    </>
                  )}
                </Space>
                <input
                  ref={uploadRef}
                  type="file"
                  id="upload"
                  value={uploadPath || ''}
                  style={{ display: 'none' }}
                  onChange={(e) => {
                    const file = e.target.files[0];
                    setUploadData(file);
                    setUploadPath(e.target.value);
                  }}
                />
              </div>
            }

            <div style={{ textAlign: 'right' }}>
              {showButton !== false && disable === true && (
                <Button
                  style={{ marginRight: 10 }}
                  onClick={() => {
                    setAnnouncementDialog(true);
                    form1.setFieldsValue({
                      announcementTime: moment(),
                      title: '更新點數制度',
                      content: `1.住戶於繳交管理費後，將會依坪數匯入住戶點數帳戶(1坪=${
                        communityDataArr.managementFeeConvertPoint
                      }點)\n2.若住戶選擇以年繳方式繳交管理費，將會於每月${
                        communityDataArr.annualPaymentImportDate
                      }號匯入\n3.點數提供現金儲值方式（1點＝${
                        communityDataArr.pointValue
                      }元)，將會併入下個月帳單進行繳費${
                        communityDataArr.isClearPoint
                          ? `\n4.點數將會於${communityDataArr.clearDate}天過後清空`
                          : ''
                      } `,
                    });
                    setPointFile(communityDataArr?.pointFile);
                  }}
                >
                  發佈公告
                </Button>
              )}
              <Button
                type="secondary"
                onClick={async () => {
                  setDisable((pre) => !pre);
                  console.log(communityDataArr);
                  if (disable === false) {
                    try {
                      let NewPointFile = communityDataArr?.pointFile?.name
                        ? communityDataArr.pointFile
                        : {};
                      if (communityDataArr?.pointFile?.name && uploadData) {
                        await uploads.remove(communityDataArr.pointFile.id);
                      }
                      if (uploadData) {
                        const body = new FormData();
                        body.append('files', uploadData);
                        const res = await fetch(
                          '/newUploads?type=communityData',
                          {
                            method: 'POST',
                            body,
                            headers: {
                              authorization:
                                window.localStorage['feathers-jwt'],
                            },
                          }
                        );
                        const { showPath, _id } = await res.json();
                        NewPointFile = {
                          path: showPath,
                          name: uploadData.name,
                          id: _id,
                        };
                      }
                      await communityData.patch(communityDataArr._id, {
                        ...communityDataArr,
                        pointFile: NewPointFile,
                      });
                      message.success('已更新設定參數');
                    } catch (error) {
                      message.error('更新失敗');
                    }
                  }
                }}
              >
                {disable === true ? '編輯' : '完成'}
              </Button>
            </div>
          </Card.Content>
        </Card>
      </div>

      {/* 公告發佈 */}
      <Dialog
        hasMask
        className={styles.dialog}
        visible={announcementDialog}
        onOk={() => {
          form1.submit();
        }}
        onCancel={() => {
          setAnnouncementDialog(false);
          setPointFile(communityDataArr?.pointFile);
        }}
        onClose={() => {
          setAnnouncementDialog(false);
          setPointFile(communityDataArr?.pointFile);
        }}
      >
        <Form
          form={form1}
          name="basic"
          labelCol={{ span: 6 }}
          wrapperCol={{ span: 18 }}
          onFinish={onFinishAnnouncement}
          autoComplete="off"
        >
          <h3>新增公告</h3>
          <Form.Item
            label="發佈時間"
            name="announcementTime"
            rules={[{ required: true, message: '請選擇發佈時間' }]}
          >
            <DatePicker showTime={{ format: 'HH:mm:ss' }} />
          </Form.Item>
          <Form.Item
            label="標題"
            name="title"
            rules={[{ required: true, message: '請選擇標題' }]}
          >
            <Input />
          </Form.Item>

          <Form.Item
            label="內容"
            name="content"
            rules={[{ required: true, message: '請輸入內容' }]}
          >
            <Input.TextArea aria-label="TextArea" />
          </Form.Item>
          <Form.Item label="檔案上傳">
            <Space wrap>
              <Button
                style={{ marginRight: 10 }}
                onClick={() => {
                  uploadAnnouncement.current.click();
                }}
              >
                檔案上傳
              </Button>
              {uploadAnnouncementData && (
                <>
                  <Typography.Text type="secondary">
                    {uploadAnnouncementData.name}
                  </Typography.Text>
                  <Button
                    text
                    onClick={() => {
                      setUploadAnnouncementData(null);
                      // setUploadAnnouncementPath('');
                    }}
                    style={{ opacity: 0.45 }}
                  >
                    <DeleteOutlined style={{ marginLeft: 10 }} />
                  </Button>
                </>
              )}
              {!uploadAnnouncementData && pointFile?.name && (
                <>
                  <Typography.Text type="secondary">
                    {communityDataArr?.pointFile?.name}
                  </Typography.Text>
                  <Button
                    text
                    onClick={() => {
                      setUploadAnnouncementData(null);
                      setPointFile({});
                    }}
                    style={{ opacity: 0.45 }}
                  >
                    <DeleteOutlined style={{ marginLeft: 10 }} />
                  </Button>
                </>
              )}
            </Space>
            <input
              ref={uploadAnnouncement}
              type="file"
              id="upload"
              style={{ display: 'none' }}
              onChange={(e) => {
                const file = e.target.files[0];
                setUploadAnnouncementData(file);
                // setUploadAnnouncementPath(e.target.value);
              }}
            />
          </Form.Item>
        </Form>
      </Dialog>

      <Button
        className={styles.buttonAdd}
        onClick={() => {
          setAddAccountingDialog(true);
        }}
      >
        新增點數發放
      </Button>

      <Card free>
        <Card.Content>
          <Table
            dataSource={residentPointsRecordArr}
            maxBodyHeight="70vh"
            fixedHeader
          >
            <Table.Column
              title="建立時間"
              dataIndex="createdTime"
              width={100}
              cell={(value) => moment(value).format('YYYY-MM-DD HH:mm:ss')}
            />
            <Table.Column
              title="戶號"
              dataIndex="householdNumber"
              width={100}
            />
            <Table.Column title="交易類型" dataIndex="type" width={100} />
            <Table.Column title="點數" dataIndex="point" width={100} />
            <Table.Column title="備註" dataIndex="remarks" width={100} />
            <Table.Column
              title="更新時間"
              dataIndex="updatedTime"
              width={100}
              cell={(value) => moment(value).format('YYYY-MM-DD HH:mm:ss')}
            />
          </Table>
        </Card.Content>
      </Card>
    </>
  );
};

export default HouseholdPoints;
